import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_ENC_KEY;

// Encrypt function
export const encryptData = (data, type = 'enc') => {
  try {
    if (!data) return data;
    
    if (type === 'enc') {
      const encrypted = CryptoJS.AES.encrypt(data.toString(), SECRET_KEY).toString();
      console.log('Encrypting:', data, '→', encrypted);
      return encrypted;
    }
    
    if (type === 'dec') {
      const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return decrypted || data;
    }
    
    return data;
  } catch (error) {
    console.error('Encryption/Decryption error:', error);
    return data;
  }
};

// Decrypt function
export const decryptData = (encryptedData) => {
  try {
    if (!encryptedData) return encryptedData;
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted || encryptedData;
  } catch (error) {
    console.error('Decryption error:', error);
    return encryptedData;
  }
};

// Encrypt object properties
export const encryptObjectProperties = (obj, properties) => {
  const encryptedObj = { ...obj };
  properties.forEach(prop => {
    if (encryptedObj[prop]) {
      encryptedObj[prop] = encryptData(encryptedObj[prop]);
    }
  });
  return encryptedObj;
};

// Decrypt object properties
export const decryptObjectProperties = (obj, properties) => {
  const decryptedObj = { ...obj };
  properties.forEach(prop => {
    if (decryptedObj[prop]) {
      decryptedObj[prop] = decryptData(decryptedObj[prop]);
    }
  });
  return decryptedObj;
};